<template>
  <BascCard>
    <template #header>
      <h5
        :class="$route.path.includes('jobs') ? 'bg-primary' : 'bg-purple'"
        class="text-white py-1 pl-1 header_card_job"
      >
        {{ name }}
      </h5>
    </template>
    <div>
      <b-card-text>
        <div>
          <table class="mt-2 w-100 table table-bordered">
            <tbody>
              <tr>
                <td><feather-icon icon="UserIcon" class="mr-1" />المنظمة</td>
                <td>{{ ngo_name }}</td>
              </tr>
              <tr>
                <td><feather-icon icon="HashIcon" class="mr-1" />رقم الشاغر</td>
                <td>{{ code }}</td>
              </tr>
              <tr>
                <td>
                  <feather-icon icon="SquareIcon" class="mr-1" />مجال العمل
                </td>
                <td>{{ position_type }}</td>
              </tr>
              <tr>
                <td><feather-icon icon="MapPinIcon" class="mr-1" />المكان</td>
                <td>{{ governorate }}</td>
              </tr>
              <tr>
                <td>
                  <feather-icon icon="CalendarIcon" class="mr-1" />تاريخ الإعلان
                </td>
                <td>{{ starting_date }}</td>
              </tr>
              <tr>
                <td>
                  <feather-icon icon="CalendarIcon" class="mr-1" />تاريخ إغلاق
                  الشاغر
                </td>
                <td>{{ closing_date }}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </b-card-text>
    </div>
    <div class="d-flex justify-content-end mt-2">
      <router-link
        v-if="$route.name == 'jobs' || $route.name == 'ngo-jobs'"
        :to="
          $route.params.id
            ? {
                name: 'jobs-info-ngo',
                params: { id_info: id, id: $route.params.id },
              }
            : { name: 'jobs-info', params: { id_info: id } }
        "
      >
        <b-button
          :class="{ volunteer_layout: job === 'volunteers' }"
          :variant="`${job == 'volunteers' ? '#a21caf' : 'primary'}`"
        >
          التفاصيل
        </b-button>
      </router-link>
      <router-link
        v-else
        :to="
          $route.params.id
            ? {
                name: 'volunteer-info-ngo',
                params: { id_info: id, id: $route.params.id },
              }
            : { name: 'volunteer-info', params: { id_info: id } }
        "
      >
        <b-button
          :class="{ volunteer_layout: job === 'volunteers' }"
          :variant="`${job == 'volunteers' ? '#a21caf' : 'primary'}`"
        >
          التفاصيل
        </b-button>
      </router-link>
    </div>
  </BascCard>
</template>

<script>
import { BButton, BAvatar } from "bootstrap-vue";
import BascCard from "./BascCard.vue";

export default {
  props: [
    "name",
    "ngo_name",
    "position_type",
    "code",
    "closing_date",
    "starting_date",
    "governorate",
    "id",
    "job",
    "code",
  ],

  components: {
    BButton,
    BAvatar,
    BascCard,
  },
};
</script>
<style scoped>
.bg-purple {
  background-color: #a21caf !important;
}
.padding_top_6 {
  padding-top: 6px;
}
.margin_x_6 {
  margin-left: 6px;
  margin-right: 6px;
}
.header_card_job {
  border-top-left-radius: 5px;
  border-top-right-radius: 5px;
}
.volunteer_layout {
  background-color: #a21caf;
  color: #fff;
}
</style>
